<template>
<div>
  <b-modal :header-bg-variant="EquipamentoEdit !=  null ? EquipamentoEdit.conforme != true ? 'danger' : ''  : ''" ref="authmodal" hide-footer :title=" EquipamentoEdit == null ? 'N/D' : 'AVALIAÇÃO EQUIPAMENTO - '  + EquipamentoEdit.epi.descricaoReduzida" size="md">
    <template #modal-title>
        <div class="header-title">{{EquipamentoEdit == null ? 'N/D' : 'AVALIAÇÃO EQUIPAMENTO - '  + EquipamentoEdit.epi.descricaoReduzida}}</div>
    </template>
      <div class="modalbodyy" v-if="changeModal == 0">
          <div class="bodyscrol mb-3">
              <div style="display: flex; justify-content: end; margin-bottom: 1rem; gap: 1rem;">
                <div class="btnDownload" v-on:click="DowloadImagemCheackList"  :disabled="disableButtonDowload" :title="'Download das imagem selecionada'"><i class="fas fa-download iconDownload"></i></div>
                <div class="btnDownload" v-on:click="setChangeModal(2)"   :title="'Download das imagem selecionada'"><i class="fas fa-edit iconDownload"></i></div>
                <!-- <button class="btn btn-primary"  v-on:click="DowloadImagemCheackList"  :disabled="disableButtonDowload" :title="'Download das imagem selecionada'"><i class="fas fa-download"></i></button> -->
                <!-- <button class="ml-2 btn btn-primary"  v-on:click="setChangeModal(2)"   :title="'Download das imagem selecionada'"><i class="fas fa-edit"></i></button> -->
              </div>

              <div class="d-flex justify-content-center container-img">
                  <img class="imgDetalhada" :src="imgModal == null ? imgVazio : 'data:image/jpeg;base64,' + imgModal">
              </div>

              <div v-if="imgEqp.length > 1" class="img-wrap mt-2">
                <div class="card"  v-for="obj in this.imgEqp" v-bind:key="obj.id">
                  <img v-on:click="showDetailsImg(obj.midias.foto)" class="imgInput" :src="'data:image/jpeg;base64,' + obj.midias.foto">
                </div>
              </div>
            </div>
            <div v-if="VerificarConformidade" style="clear:both">
              <div class="espaco mt-4">

              </div>
              <hr>
                <h1 class="text-center subtitle">Inconformidades</h1>
              <div class="mt-3 margindivIn d-flex">
                <div class="com-md-12">
                      <div style="display:flex;flex-wrap: wrap;">
                        <div v-for="obj in tipoIncorformidade" class="objincoformidade" v-bind:key="obj.id">
                          <div style="display:flex">
                            <i v-if="verificarTipoIncoformidade(obj.id) == false" class="fas fa-times styleicon " ></i>
                            <img v-if="verificarTipoIncoformidade(obj.id)" class="mb-3 mr-1" src="https://static.zopone.com.br/img/survey/IconeSim (1).svg">
                            <div class="fontwidth">
                              <p class="infoLfInput">{{obj.nome == null ? 'N/D' : obj.nome}}</p>
                            </div>
                          </div>
                        </div>
                        <div v-if="EquipamentoEdit != null ? EquipamentoEdit.observacao == '' ? false : true : false" class="ml-4" style="display:flex;">
                          <i class="fas fa-times styleicon "></i>
                          <div class="fontwidth">
                            <p class="infoLfInput">Outros</p>
                          </div>
                        </div>
                      </div>
                </div>
              </div>
              <h1 class="infoLf" style="font-size:16px">Observação:</h1>
              <p class="infoLfInput">{{EquipamentoEdit != null ? EquipamentoEdit.observacao == '' ? 'N/D' : EquipamentoEdit.observacao : 'N/D' }}</p>
            </div>
      </div>
      <div v-if="changeModal == 2">
        <h1 class="TituloModal text-center">EDITAR EQUIPAMENTO</h1>
        <div>
           <Alerts ref="alert"/>
        </div>
        <div class="container body-card">
        <div class="form-body-scroll">
              <div class="form-group">
            <label class="tituloLabel">EQUIPAMENTO</label>
            <input disabled v-model="EditEquipamento.equipamento" class="form-control" type="text">

            <div style="display: flex; gap: 1rem; margin-top: 0.5rem;">
              <div style="width: 100%;">
                <label class="tituloLabel">CA</label>
                <input v-model="EditEquipamento.ca" class="form-control" type="text">
              </div>
              <div style="width: 100%;">
                <label class="tituloLabel">MARCA</label>
                <input v-model="EditEquipamento.marca" class="form-control" type="text">
              </div>
            </div>

            <div style="display: flex; gap: 1rem; margin-top: 0.5rem;">
              <div style="width: 100%;">
                <label class="tituloLabel">MODELO</label>
                <input v-model="EditEquipamento.modelo" class="form-control" type="text">
              </div>
              <div style="width: 100%;">
                <label class="tituloLabel">SÉRIE</label>
                <input v-model="EditEquipamento.serie" class="form-control" type="text">
              </div>
            </div>

            <div style="width: 100%; margin-top: 0.5rem;">
              <label class="tituloLabel">LOTE</label>
              <input v-model="EditEquipamento.lote" class="form-control" type="text">
            </div>

            <div style="width: 100%; margin-top: 0.5rem;">
              <label class="tituloLabel">DESCRIÇÃO</label>
              <textarea v-model="EditEquipamento.descricao" style="height: 100px;" class="form-control"></textarea>
            </div>

           <div v-if="EquipamentoEdit !=  null ? EquipamentoEdit.conforme != true ? true : false  : false">
              <label class="tituloLabel">OBSERVAÇÃO</label>
              <textarea v-model="EditEquipamento.observacao" style="height: 100px;" class="form-control"></textarea>
           </div>
          </div>
        </div>
        </div>
          <div class="d-flex container_cancel_save">
              <div class="cancelar">
                  <button class="button-cancel" @click="changeModal = 0">VOLTAR</button>
              </div>
              <div class="criar">
                <button class="button-save" @click="updateVistoriaEpi">SALVAR</button>
              </div>
            </div>
      </div>
    </b-modal>
</div>
</template>

<script>
import modalepisurvey from './modalepisurvey.js'
export default modalepisurvey
</script>

<style scoped>
.tituloLabel {
  font-family:  'Segoe UI';
  font-size: 14px;
  margin-bottom: 0.1rem;
}
.container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1rem;
    column-gap: 10px;
   }
.button-cancel,
.button-save{
  margin-top: 1rem;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 170px;
  height: 35px;
  font-family: 'Segoe UI';
  font-size: 12px;
  font-weight: bold;
}
.button-cancel{
  background-color: #b60000;
  color: white;
}
.button-save{
  background-color: darkgreen;
  color: white;
}
.container-img{
  background: #ededed;
  padding: 1rem;
  border-radius: 7px
}
.big-checkbox {width: 20px; height: 20px;}
.checkText {
  font-size: 16px;
}
.btnDownload{
  margin-top: 0px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #cbe9cf 0% 0% no-repeat padding-box;
  outline: none;
}
.btnDownload:hover{
  background: #86c28e;
}
.iconDownload {
  color: rgb(19, 59, 26);
}
.body-card{
  height: fit-content;
}
.form-body-scroll{
  overflow-y: auto;
  height:  100%;
}

.checkTextLeft {
  font-size: 16px;
  margin-left:70px ;
}
p {
  font-size: 20px;
}
.styleicon{
  font-size: 20px;
  margin-right: 8px;
  color: red;
}
.btn-edit{
  width: 80px;
  height: 40px;
  color: white;
  background: #008148;
}
.btn-edit:hover{
  color: white;
  background: #008147e1;
}
.margindivIn{
  margin-left: 90px;
}
.modalbodyy{
  height: fit-content;
  overflow-y: auto;
}
.groupinconformidade{
  display: inline;
  position: relative;
  float: left;
}
.fontwidth{
  width: 80px;
}
.TituloModal {
  color: green;
}
.espaco{
  height: 20px;
}
.objincoformidade{
  position: relative;
  display: inline;
  float: left;
  margin-right: 90px;
  margin-left: 25px;
}

.imgInput {
  cursor: pointer;
  height: 75px;
  width: 75px;
  object-fit: cover;
}
.infoLfModal{
  margin-bottom: 0px;
  text-align: left;
  font: normal normal normal 15px/10px ;
  letter-spacing: 0px;
  color: #008148;
  font-size: 20px;
  opacity: 1;
}
.infoLfInput{
  text-align: left;
  font: normal normal 600 17px/11px ;
  letter-spacing: 0px;
  color: #4F4C4D;
  font-size: 15px;
  opacity: 1;
  font-weight: bold;
}

.img-wrap {
border: red;
position: relative;
align-items: center;
display: flex;
gap: 2rem;
float:left;
}

.img-wrap #clear {
position: absolute;
top: 2px;
right: 2px;
z-index: 100;
}
.imgDetails {
  width: 400px;
  height: 400px;
  object-fit: contain;
}
.checkPrin {
  width: 25px;
  height: 25px;
}

.checkList{
  width: 20px;
  height: 20px;
}
.butttonDowload {
  margin-top: 30px;
}
.imgDetalhada{
  margin-bottom: 0px;
  width: 400px;
  height: 400px;
  object-fit: contain;
}
.bordaImgDetalhe{
  widows: 450px;
  height: 450px;
  border-color: black;
}

</style>



// WEBPACK FOOTER //
// src/views/private/Survey/components/modalepisurvey/modalepisurvey.vue